<script setup>
import { useManufacturersStore } from './stores/manufacturers';

const store = useManufacturersStore();
const cfg   = window.ebusManufacturers || {};
const i18n  = cfg.i18n || {};
</script>

<template>
  <div class="dashboard__info">
    <h2 class="manufactor__title">{{ store.currentManufacturer.title }}</h2>
    <div v-if="store.currentManufacturer.logo" class="manufactor__logo">
      <img
        :src="store.currentManufacturer.logo"
        :style="store.currentManufacturer.logo_width ? `width:${store.currentManufacturer.logo_width}% !important` : ''"
      />
    </div>
    <div class="manufactor__buses-number__label">{{ i18n.totalBuses || '' }}</div>
    <h3 class="manufactor__buses-number">{{ store.currentManufacturer.bus_total || i18n.tbc || 'Tbc' }}</h3>
    <ul class="list">
      <li v-for="s in store.currentManufacturer.bus_sizes" :key="s" class="list__item">
        <span :class="`bus-size bus-size--${s}`"></span>
        {{ (i18n.busSizes || {})[s] || s }}
      </li>
    </ul>
  </div>
</template>
